<template>
  <MenuItem @click.stop="toggleSidebar" v-bind="$attrs">
    <slot />
  </MenuItem>
</template>

<script>
  import { mapActions } from 'vuex'
  import MenuItem from './MenuItem'

  export default {
    components: {
      MenuItem,
    },

    props: {
      name: { type: String, required: true },
      direction: { type: String, default: null },
      size: { type: String, default: null }
    },

    methods: {
      ...mapActions('slideSidebar', ['slideSidebarToggle']),

      toggleSidebar () {
        const { name, direction, size } = this
        this.slideSidebarToggle({ name, direction, size })
      }
    }
  }
</script>
